import styled from '@emotion/styled';
import { Typography, Button } from '@mgmresorts/mgm-ui';

export const StyledHeading = styled(Typography)<{ $hasPromoBanner?: boolean }>`
  ${({ theme, $hasPromoBanner }) => `
    color: ${theme.semantic.FgDefault};
    padding-top: ${$hasPromoBanner ? '0px' : `${theme.semantic.SpaceComponentL}px`};
    margin-top: ${theme.semantic.SpaceComponentXl}px;
    margin-bottom: ${$hasPromoBanner ? `${theme.semantic.SpaceComponentM}px` : `${theme.semantic.SpaceComponentL}px`};
    ${
      $hasPromoBanner &&
      `
        text-align: center;
        @media (max-width: 768px) {
          margin-top: ${theme.semantic.SpaceComponentL}px;
          padding-top: ${theme.semantic.SpaceComponentNone}px;
          font-size: ${theme.semantic.HeadingMedium2.fontSize}px;
          margin-bottom: ${theme.semantic.SpaceComponentM}px;
        }
      `
    }
  `}
`;

export const StyledInputContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledButton = styled(Button)<{ $hasPromoBanner?: boolean }>`
  ${({ theme, $hasPromoBanner }) => `
    margin-top: ${theme.semantic.SpaceComponentL}px;
    ${
      $hasPromoBanner &&
      `
        @media (max-width: 768px) {
          margin-top: ${theme.semantic.SpaceComponentM}px;
        }
      `
    }
  `}
`;

export const StyledSubTitle = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
